export default __webpack_public_path__ + "static/media/cube-pattern.a728a541.png";